import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * Fire when the user taps on the Undo icon
 */
const logCustomRouteEditorUndoCtaTapped = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('custom route editor undo cta tapped', {}, callback);
};

export default logCustomRouteEditorUndoCtaTapped;
